import { Button, type ButtonProps } from '@mantine/core';
import type { HTMLAttributes } from 'react';

export type InputButtonProps = ButtonProps &
  HTMLAttributes<HTMLButtonElement> & {
    isActive?: boolean;
    isLight?: boolean;
  };

export const InputButton = ({
  isActive,
  isLight,
  ...props
}: InputButtonProps) => {
  return (
    <Button
      color={isLight ? 'dark.6' : 'dark.7'}
      size="xs"
      styles={{
        root: {
          border: '2px solid transparent',
          borderColor: 'transparent',
          ...(isActive && { borderColor: 'var(--mantine-color-brand-5)' }),
        },
      }}
      {...props}
    />
  );
};
